import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { uploadFiles } from "Thunks";
import { sendUrl } from "Thunks";
import { initUploads, displayFlashMessage } from "Actions";
import { isUrl } from "Utils";

import styles from "./Wheretobill.local.scss";
import _ from "i18n";

import WheretobillComponent from "./WheretobillComponent";

class WheretobillContainer extends Component {
  onDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      toast.error(
        <div>
          <span>{_("Some files are invalid : ")}</span>
          <ul>
            {rejectedFiles.map(file => <li key={file.name}>{file.name}</li>)}
          </ul>
        </div>,
        { autoClose: true }
      );
    }

    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }

    const { uploadFiles } = this.props;

    uploadFiles(acceptedFiles);
  };

  onDragEnter = () => {
    $(`.${styles.big}`).addClass(styles.active);
  };

  componentDidUpdate(prevProps) {
    const { initUploads, uploaded, displayFlashMessage } = this.props;
    if (uploaded) {
      $(`.${styles.check}`).show(500);
      setTimeout(() => {
        initUploads();
        $(`.${styles.check}`).hide();
      }, 1500);

      displayFlashMessage("SUCCESS", "Invoice File sended successfully");
    }
  }

  handleChange = e => {
    if (isUrl(e.currentTarget.value)) {
      document.getElementById("sendUrl").classList.add(styles.active);
    }
  };
  handleSend = e => {
    const { sendUrl } = this.props;
    const url = document.getElementById("billUrl").value;
    sendUrl(url);
  };

  render() {
    const { uploading, uploaded, loggedAs } = this.props;
    if (loggedAs !== "CLIENT") {
      return null;
    }

    return (
      <div className="pellet cell medium-6 large-3">
        <WheretobillComponent
          uploading={uploading}
          uploaded={uploaded}
          onDrop={this.onDrop}
          onDragEnter={this.onDragEnter}
          onChange={this.handleChange}
          onSend={this.handleSend}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  uploading: state.wheretobill.uploading,
  uploaded: state.wheretobill.uploaded,
  user: state.auth.user,
  loggedAs: state.auth.loggedAs
});

const mapDispatchToProps = dispatch => ({
  initUploads: () => dispatch(initUploads()),
  uploadFiles: files => dispatch(uploadFiles(files)),
  sendUrl: url => dispatch(sendUrl(url)),
  displayFlashMessage: (status, msg) =>
    dispatch(displayFlashMessage(status, msg))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WheretobillContainer);



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Wheretobill/WheretobillContainer.js